import React, { useEffect, useState } from 'react';
import { CustomerDocumentModelItem } from '../models/superbit-api-models';
import { Dropdown, MenuProps } from 'antd';
import { CustomerCardModel } from '../models/CustomerCardModel';
import ClientDocument from '../clients/documents/_ClientDocument';
import UploadDocumentPopUp from '../clients/documents/_UploadDocumentPopUp';
import ClientFolderDocuments from '../clients/documents/_ClientFolderDocuments';
import MessegePopup from '../subscribers/popups/_MessegePopup';
import EditFolderInfoPopUp from '../clients/_EditFolderInfoPopUp';
import '../clients/_ClientFiles.css';
import { setCreateTreatmentFrom } from '../app-context/tasksSlice';
import { useDispatch } from 'react-redux';

interface Props {
    actionBtns: boolean | null;
    customerId: string;
    relationId: string;
    retationType: number;
    displayFile: (fileUrl: string) => void;
    showAddTreatmentPopup: (customerId: string, policyId: string, type: number) => void;
}

const SignDocuments = (props: Props) => {
    const dispatch = useDispatch();
    const customerCardModel: CustomerCardModel = new CustomerCardModel();

    const [documentsList, setDocumentsList] = useState<CustomerDocumentModelItem[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [apiUrl, setApiUrl] = useState<string>('');
    // const [apiUrl, setApiUrl] = useState<string>(props.config.apiUrl);
    const [showModelUploadDocument, setShowModelUploadDocument] = useState<{ show: boolean, customerId: string }>({ show: false, customerId: '' });

    const [foldersList, setFoldersList] = useState<any[]>([]);

    const [showPopUpMessage, setShowPopUpMessage] = useState<boolean>(false);
    const [message, setMessage] = useState<string>('');
    const [hasNewDocument, setHasNewDocument] = useState<boolean>(false);
    const [showEditFolderPopUp, setShowEditFolderPopUp] = React.useState<{ folderid: string, show: boolean }>({ folderid: '', show: false });

    // get folders

    const getFolders = async () => {
        setLoading(true);
        const foldersData: any = await customerCardModel.customerDocumentsGetFoldersForCustomer(props.customerId);
        // console.log('getFolders', foldersData);
        if (foldersData && foldersData.length > 0) {
            setFoldersList(foldersData);
        }
        setLoading(false);
    }

    const showUploadDocument = () => {
        setShowModelUploadDocument({
            show: true,
            customerId: props.customerId
        });
    }

    const getDocuments = async () => {
        // Simulating an API call to fetch documents
        setLoading(true);
        setDocumentsList([]);
        const documentsData: any = await customerCardModel.customerDocumentsGetByRelation(props.relationId);
        console.log('getDocuments-documentsData', documentsData)
        if (documentsData && documentsData.length > 0) {
            const documents = documentsData.sort((a: any, b: any) => new Date(b.createdDate).getTime() - new Date(a.createdDate).getTime());
            console.log('getDocuments-documents', documents)
            setDocumentsList(documents);
        }
        setLoading(false);

    }

    const addPolicyOptions: MenuProps['items'] = [
        {
            key: '1',
            label: (
                <li className="pointer rtl"
                    onClick={() => showUploadDocument()}
                >
                    <label htmlFor="file">{"הוספת מסמך"}</label>
                </li>
            ),
        },
    ]

    useEffect(() => {
        const savedApiUrl = localStorage.getItem('apiUrl');
        if (savedApiUrl) {
            setApiUrl(savedApiUrl)
        }
        getDocuments();
        getFolders()
    }, [])


    const onClose = () => {
        setShowPopUpMessage(false);
        getFolders();
        getDocuments();
    }


    const loadData = () => {
        getFolders();
        getDocuments();
    }

    const setUpAddTreatmentPopup = (type: number) => {
        console.log('setUpAddTreatmentPopup', type);
        props.showAddTreatmentPopup(props.customerId, props.relationId, type); // props.relationId = policyId
        dispatch(setCreateTreatmentFrom({ type: 'sign', id: props.relationId }));
    }

    const onSelectDocument = (document: any) => {
        if (props.displayFile) {
            props.displayFile(document);
        }
    }

    return (

        <div style={{ borderBottom: '1px solid #9399b7', backgroundColor: '#eef3f6' }}>
            <div style={{ paddingBottom: "15px", marginBottom: "20px", paddingTop: "30px" }} >

                {
                    showPopUpMessage &&
                    <MessegePopup
                        message={message}
                        statusMessege='success'
                        show={showPopUpMessage}
                        onClose={onClose}

                    />
                }

                {showEditFolderPopUp.show &&
                    <EditFolderInfoPopUp
                        folderList={foldersList}
                        folderId={showEditFolderPopUp.folderid}
                        onClose={() => {
                            setShowEditFolderPopUp({ folderid: '', show: false });
                            setMessage('תיקייה עודכנה בהצלחה');
                            setShowPopUpMessage(true);
                            getFolders();
                        }}
                        customerId={props.customerId}
                    />
                }
                {
                    showModelUploadDocument.show &&
                    <UploadDocumentPopUp
                        onClose={() => {
                            setShowModelUploadDocument({ show: false, customerId: '' })
                            if (hasNewDocument) {
                                setMessage('מסמך נוסף בהצלחה')
                                setShowPopUpMessage(true)
                                setHasNewDocument(false);
                            }
                        }}
                        config={{ customerId: showModelUploadDocument.customerId, relationId: props.relationId }}
                        fromPolicy={"1"}
                        relationType={props.retationType}
                        onSetHasNewDocument={() => setHasNewDocument(true)}
                    />
                }
                <div className="">
                    <div className='flex-space-between' style={{ height: '50px' }}>
                        <div className="row-title">
                            <div className="row-title">מסמכים</div>
                        </div>
                        <div className='flex-centered' style={{ marginLeft: '10px' }}>
                            {props.actionBtns == true &&
                                <Dropdown menu={{ items: addPolicyOptions }}>
                                    <button type="button" className="button blue has-icon flex-centered flex-justify-center">
                                        <div className="icon add"></div>
                                        הוסף מסמך
                                    </button>
                                </Dropdown>
                            }
                        </div>

                    </div>
                    <div className="client-files-header-section" style={{ display: 'flex', gap: '10px', justifyContent: 'flex-start', alignItems: 'center' }}>
                        <div style={{ width: '50px' }}>
                            "                          {/* סמל  */}"
                        </div>
                        <div style={{ width: '170px' }}>
                            שם הקובץ
                        </div>
                        <div style={{ width: '250px' }}>
                            שיוך
                        </div>
                        <div style={{ width: '170px' }}>
                            נושא
                        </div>
                        <div style={{ width: '170px' }}>
                            נוצר ע"י
                        </div>
                        <div style={{ width: '170px' }}>
                            תאריך ההוספה
                        </div>
                        <div style={{ width: '170px' }}>
                            {/* קובץ  */}
                        </div>
                    </div>


                    <div
                        style={{ minHeight: 100, maxHeight: '600px', overflowY: 'auto' }}>
                        {
                            foldersList && foldersList.length > 0 &&
                            foldersList.map((folder: any, index: any) => {
                                if (documentsList.filter((doc: any) => doc.customerDocument.customerDocumentFolderId == folder.id).length > 0) {
                                    console.log('map-folder', folder)
                                    return (
                                        <div key={index}>
                                            <ClientFolderDocuments
                                                folder={folder}
                                                documentsList={documentsList.filter((doc: any) => doc.customerDocument.customerDocumentFolderId == folder.id)}
                                                apiUrl={apiUrl}
                                                displayClientDocument={(doc: any) => onSelectDocument(doc)}
                                                fromPolicy={true}
                                                policyId={props.relationId}
                                                fromSigning={true}
                                                loadData={loadData}
                                                showEditFolderPopUp={(folderId: string) => {
                                                    setShowEditFolderPopUp({ folderid: folderId, show: !showEditFolderPopUp.show });
                                                }}
                                                showAddTreatmentPopup={setUpAddTreatmentPopup}
                                            />
                                        </div>
                                    )
                                }
                            })
                        }
                        {documentsList.filter((doc: any) => !doc.customerDocument.customerDocumentFolderId || doc.customerDocument.customerDocumentFolderId == null).map((document: any, index: any) => {
                            return (
                                <div key={index}>
                                    <ClientDocument documentDetails={document.customerDocument} config={{
                                        apiUrl: apiUrl,
                                        displayFile: (doc: any) => {
                                            onSelectDocument(doc);
                                        }
                                    }} loadData={loadData}
                                        fromPolicy={true}
                                        policyId={props.relationId}
                                        fromSigning={true}
                                        showAddTreatmentPopup={setUpAddTreatmentPopup}
                                    />
                                </div>
                            )

                        })}

                    </div>
                </div>
            </div>
        </div>
    )
}

export default SignDocuments;